export type Project = {
  title: string;
  category: string;
  challenge: string;
  solution: string;
  outcome: string;
  technologies: string[];
};

export const projects: Project[] = [
  {
    title: 'Lead Intake Automation',
    category: 'Automation',
    challenge:
      'A service business was receiving leads through forms, voicemail notes, email, and referrals. Response times varied and ownership was unclear.',
    solution:
      'MaytoMation created a central intake workflow with classification, routing rules, CRM updates, email notifications, and a daily exception report.',
    outcome:
      'The team gained a reliable first-response process and a clear view of every open opportunity.',
    technologies: ['React', 'TypeScript', 'CRM API', 'Email automation', 'Operational dashboard']
  },
  {
    title: 'Contractor Quote Generator',
    category: 'Custom Software',
    challenge:
      'Quotes were manually assembled from old documents and individual memory, creating inconsistent scope language and missed line items.',
    solution:
      'A guided quote builder was built with reusable assemblies, approval states, PDF output, and editable scope notes.',
    outcome:
      'Quote creation became faster and leadership gained a maintainable pricing structure.',
    technologies: ['React', 'Node.js', 'PostgreSQL', 'PDF generation', 'Role-based review']
  },
  {
    title: 'Customer Portal',
    category: 'Software Platform',
    challenge:
      'Customers needed a single place to view requests, documents, invoices, and project status instead of searching email threads.',
    solution:
      'MaytoMation designed a secure portal with customer accounts, document uploads, internal notes, and notification workflows.',
    outcome:
      'Customer communication became more organized and staff spent less time resending information.',
    technologies: ['React Router', 'API integration', 'Authentication', 'Document storage', 'Audit logs']
  },
  {
    title: 'Business Dashboard',
    category: 'Reporting',
    challenge:
      'Managers were pulling reports from several systems and manually reconciling them before weekly meetings.',
    solution:
      'A reporting dashboard normalized operational data, highlighted exceptions, and created weekly summary views.',
    outcome:
      'Weekly reporting moved from spreadsheet assembly to decision-making.',
    technologies: ['Data pipelines', 'Charts', 'Scheduled syncs', 'PostgreSQL', 'Executive reporting']
  },
  {
    title: 'Infrastructure Audit',
    category: 'Infrastructure',
    challenge:
      'A company did not have a reliable inventory of domains, hosting accounts, backups, DNS, admin users, or recovery procedures.',
    solution:
      'MaytoMation performed discovery, documented ownership, verified backups, mapped dependencies, and prioritized remediation.',
    outcome:
      'The business received a practical risk roadmap and a supportable technical record.',
    technologies: ['DNS review', 'Backup verification', 'Access inventory', 'System diagrams', 'Runbooks']
  },
  {
    title: 'Network Documentation Project',
    category: 'Network & WiFi',
    challenge:
      'A property network had grown over time with unlabeled switches, unclear ISP equipment, and inconsistent WiFi coverage.',
    solution:
      'Equipment was inventoried, closets were photographed, ports were labeled, and a support packet was created with diagrams and next steps.',
    outcome:
      'Future service calls became easier and the owner had a clear upgrade plan.',
    technologies: ['Network inventory', 'Rack documentation', 'WiFi planning', 'Port maps', 'Support handoff']
  }
];
